import Vue from 'vue';
import oa_icon from '@/components/OaIcon.vue'; // svg组件

// register globally
Vue.component('svg-icon', oa_icon);

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);
